import { InputAdornment, TextField, InputLabel } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'isIcon' && prop !== 'margintop' && prop !== 'width'
})(
  ({ theme, error, width, margintop, isIcon }) => ({
    gap: "8px",
    width: width || "100%",
    marginTop: margintop,
    borderRadius: "0px !important",
    "& .MuiFormHelperText-root": {
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "20px",
      margin: "-8px 0 !important",
      fontFamily: "Lexend"
    },
    "& .MuiInputBase-root": {
      background: theme.palette.customColor.White,
      paddingRight: isIcon ? "20px !important" : 0,
      padding: "0px",
      borderRadius: "0px !important"
    },

    "& .MuiInputBase-input": {
      borderRadius: "0px !important",
      padding: "10px 41px 10px 14px",
      fontSize: "14px !important",
      lineHeight: "20px !important",
      fontWeight: "400",
      fontFamily: "Lexend !important",
      "&::placeholder": {
        opacity: 0.5,
        fontFamily: "Lexend !important"
      },
      touchAction: "manipulation",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: error && `1px solid ${theme.palette.customColor.red}!important`,
    },
    ".Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderWidth: "1px !important",
      //   borderColor: `${theme.palette.colors.fieldActiveBorder} !important`,
    },
    "& input[type='number']::-webkit-outer-spin-button, & input[type='number']::-webkit-inner-spin-button":
      {
        WebkitAppearance: "none",
        margin: 0,
      },
    "& input[type='number']": {
      MozAppearance: "textfield",
    },
    [theme.breakpoints.up("md")]: {
      width: "100%",
    },
  })
);

export const StyledInputAdornment = styled(InputAdornment)(() => ({
  position: "absolute",
  right: "10px",
  button: {
    marginRight: "-8px !important",
  },
  ".visible-icon": {
    width: "20px",
    height: "20px",
  },
}));
export const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  color: `${theme.palette.primary.main} !important`,
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "15px",
  margin: "5px 0px",
  "& .required": {
    color: "red",
  },
}));
